// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grey[data-v-337e3718]{color:rgba(0,0,0,0.54)}", "",{"version":3,"sources":["webpack://./src/components/application/VProfileMenu/CompanySettings/ShiftsSettings/Range/ShiftRange.styl"],"names":[],"mappings":"AAAA,uBACE,sBAAO","sourcesContent":[".grey\n  color: rgba(0, 0, 0, .54);"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
